import { EntityFile } from "../../entity/EntityFile";

export class DtoFilesPutRes extends EntityFile {}
